import React, { useContext, useState } from "react";
import classes from "./ServicesComponents.module.scss";
import { OrgIdContext } from "../../store/orgId_context";
import { servicesCols, servicesFields } from "./servicesColumns";
import axios from "axios";
import Button from "../UI/Button";
import CertificateField from "./CertificateField";
import { ReactComponent as EditBtn } from "../../assets/enter.svg";
import { Modal } from "react-bootstrap";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ServicesTable = ({
  data,
  dataType,
  isEditMode,
  onCancelEditing,
  // getData,
}) => {
  console.log(data);
  const [editedValues, setEditedValues] = useState([]);
  const [errorSaving, setErrorSaving] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [openedService, setOpenedService] = useState(null);
  const [isEmailInvalid, setIsEmailInvalid] = useState(false);
  const { isMaintainer } = useContext(OrgIdContext);

  const handleFieldChange = (rowNumber, fieldId, fieldValue) => {
    // Check if there is already an entry for the given rowNumber
    const existingRow = editedValues.find(
      (item) => item.rowNumber === rowNumber
    );

    if (existingRow) {
      // Update the existing row
      const updatedRow = {
        ...existingRow,
        [fieldId]: fieldValue,
      };

      // Update the editedValues state with the updatedRow
      setEditedValues((prevValues) =>
        prevValues.map((item) =>
          item.rowNumber === rowNumber ? updatedRow : item
        )
      );
    } else {
      // Add a new row entry
      const newRow = {
        rowNumber,
        [fieldId]: fieldValue,
      };

      // Update the editedValues state with the newRow
      setEditedValues((prevValues) => [...prevValues, newRow]);
    }
  };

  const checkDisabled = (dataIndex, id) => {
    return (
      !isEditMode || // Condition 1: isEditMode is false
      data[dataIndex].ServiceEndPointCode__NonCustomerEditable || // Condition 2: ServiceEndPointCode__NonCustomerEditable is true
      (isMaintainer // Check if user is maintainer
        ? !data[dataIndex].ServiceEndPointCode__MaintainerUIRules?.includes(id) // Condition 3 for maintainer
        : !data[dataIndex].ServiceEndPointCode__UserUIRules?.includes(id))
    ); // Condition 3 for non-maintainer}
  };

  const onSaveValues = () => {
    if (!isEmailInvalid) {
      if (editedValues.length === 0) onCancelHandler();
      editedValues.forEach((item) => {
        let { rowNumber, ...dataToSave } = item;
        setErrorSaving(null);

        axios
          .post(
            apiRequestAddress,
            {
              jsonrpc: "2.0",
              method: "Data.Modify",
              params: {
                entity: "EU_AOrg_ServicesEndpoints",
                filter:
                  "ServiceEndPointCode='" +
                  data[rowNumber].ServiceEndPointCode +
                  "'",
                values: dataToSave,
              },
              id: 5123,
            },
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (
              res.data.result &&
              res.data.result.status.toLowerCase() === "ok"
            ) {
              // onCancelEditing();
              onCancelHandler();
              // if (isFromModal) {
              //   setIsFormOpen(false);
              //   setOpenedService(null);
              //   getData();
              // } else onCancelHandler();
            } else {
              setErrorSaving("An error has occured.");
            }
          });
      });
    }
  };

  const onOpenFormHandler = (serviceIndex) => {
    setIsFormOpen(true);
    setOpenedService(serviceIndex);
  };

  const onCloseFormHandler = () => setIsFormOpen(false);

  const onCancelHandler = () => {
    onCancelEditing();
    setIsFormOpen(false);
    setOpenedService(null);
  };

  return (
    <>
      <div className={`${classes.servicesTableCont}`}>
        {data && <p>{data[0].Notes}</p>}
        <table className={classes.servicesTable}>
          <thead>
            <tr>
              {isEditMode && <th style={{ borderRight: "none" }}></th>}
              {servicesCols.map((col) => (
                <th key={col}>
                  <div
                    style={{
                      resize: "horizontal",
                      overflow: "auto",
                      minWidth: "180px",
                    }}
                  >
                    {col}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data &&
              dataType &&
              data.map(
                (
                  item,
                  index // one item in data means one service
                ) => (
                  <tr key={`cred-row-${index}`}>
                    {isEditMode && (
                      <div
                        className={`${classes.editServiceBtn} ${
                          data[index]
                            .ServiceEndPointCode__NonCustomerEditable &&
                          classes.nonEditable
                        }`}
                        onClick={() => onOpenFormHandler(index)}
                      >
                        <EditBtn />
                      </div>
                    )}
                    {servicesFields.map((field, fieldIndex) => (
                      <td
                        key={`${field.name}-${index}-${fieldIndex}`}
                        className={classes.serviceTableField}
                      >
                        {dataType[field.name] &&
                          dataType[field.name].FieldType.toUpperCase() ===
                            "URL" && (
                            <CertificateField
                              isEditMode={
                                isEditMode &&
                                !data[index]
                                  .ServiceEndPointCode__NonCustomerEditable &&
                                (isMaintainer
                                  ? data[
                                      index
                                    ].ServiceEndPointCode__MaintainerUIRules?.includes(
                                      field.name
                                    )
                                  : data[
                                      index
                                    ].ServiceEndPointCode__UserUIRules?.includes(
                                      field.name
                                    ))
                              }
                              certificateId={item[field.name]}
                              serviceCode={data[index].ServiceEndPointCode}
                              className={isEditMode ? classes.nonEditableText : undefined}
                            />
                          )}
                        {(!dataType[field.name] ||
                          dataType[field.name].FieldType.toUpperCase() !==
                            "URL") &&
                          (dataType[field.name] &&
                          dataType[field.name].Type &&
                          dataType[field.name].Type === "Logical" ? (
                            <select
                              id={`${field.name}-${index}`}
                              className={
                                isEditMode &&
                                ((checkDisabled(index, field.name) &&
                                  !data[index]
                                    .ServiceEndPointCode__NonCustomerEditable &&
                                  field.name !== "ServiceEndPointCode") ||
                                  (field.name === "ServiceEndPointCode" &&
                                    data[index]
                                      .ServiceEndPointCode__NonCustomerEditable))
                                  ? classes.nonEditableText
                                  : ""
                              }
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  field.name,
                                  e.target.value
                                )
                              }
                              disabled={checkDisabled(index, field.name)}
                              defaultValue={item[field.name]}
                            >
                              <option value="true">True</option>
                              <option value="false">False</option>
                            </select>
                          ) : dataType[field.name] &&
                            dataType[field.name]["_validValues"] &&
                            dataType[field.name]["_validValues"].length > 0 ? (
                            <select
                              id={`${field.name}-${index}`}
                              defaultValue={item[field.name]}
                              className={
                                isEditMode &&
                                ((checkDisabled(index, field.name) &&
                                  !data[index]
                                    .ServiceEndPointCode__NonCustomerEditable &&
                                  field.name !== "ServiceEndPointCode") ||
                                  (field.name === "ServiceEndPointCode" &&
                                    data[index]
                                      .ServiceEndPointCode__NonCustomerEditable))
                                  ? classes.nonEditableText
                                  : ""
                              }
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  field.name,
                                  e.target.value
                                )
                              }
                              disabled={checkDisabled(index, field.name)}
                            >
                              {dataType[field.name]["_validValues"].map(
                                (option, optIndex) => (
                                  <option
                                    key={`${field.name}-${index}-option-${optIndex}`}
                                    id={`${field.name}-${index}-option-${optIndex}`}
                                    value={option.Title}
                                  >
                                    {option.Title}
                                  </option>
                                )
                              )}
                              <option value=""></option>
                            </select>
                          ) : (
                            <input
                              type={
                                // field.isPass
                                //   ? "password"
                                //   :
                                field.isEmail
                                  ? "email"
                                  : dataType[field.name]
                                  ? dataType[field.name].FieldType
                                  : "text"
                              }
                              id={`${field.name}-${index}`}
                              defaultValue={item[field.name]}
                              disabled={checkDisabled(index, field.name)}
                              onFocus={(e) => {
                                if (
                                  dataType[field.name].Type &&
                                  dataType[field.name].Type === "DateTime"
                                ) {
                                  e.currentTarget.type = "date";
                                  e.currentTarget.focus();
                                }
                              }}
                              onBlur={(e) => {
                                if (field.isEmail) {
                                  if (
                                    !e.currentTarget.checkValidity() &&
                                    e.currentTarget.value.length > 0
                                  )
                                    setIsEmailInvalid(true);
                                  else setIsEmailInvalid(false);
                                }
                              }}
                              className={`${
                                isEditMode &&
                                ((checkDisabled(index, field.name) &&
                                  !data[index]
                                    .ServiceEndPointCode__NonCustomerEditable &&
                                  field.name !== "ServiceEndPointCode") ||
                                  (field.name === "ServiceEndPointCode" &&
                                    data[index]
                                      .ServiceEndPointCode__NonCustomerEditable))
                                  ? classes.nonEditableText
                                  : ""
                              } ${field.isPass ? classes.key : ""}`}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  field.name,
                                  e.target.value
                                )
                              }
                            />
                          ))}
                      </td>
                    ))}
                  </tr>
                )
              )}
          </tbody>
        </table>
      </div>
      {isEditMode && (
        <>
          <button
            className={`${classes.refreshBtn} px-4 py-1`}
            onClick={() => {
              onCancelHandler();
              setErrorSaving(null);
            }}
          >
            Cancel
          </button>
          <Button
            className={`px-5 py-1 ${classes.saveBtn}`}
            onClick={onSaveValues}
            disabled={isEmailInvalid}
          >
            Save
          </Button>
          {isEmailInvalid && (
            <p className={classes.errorMsg}>
              Please enter a valid email address.
            </p>
          )}
        </>
      )}
      {(openedService || openedService === 0) && (
        <Modal
          show={isFormOpen}
          onHide={onCloseFormHandler}
          className={classes.modalMain}
          dialogClassName={classes.modalMain}
          centered
        >
          <Modal.Body>
            <h3 className={classes.editModalTitle}>
              {data[openedService]["ServiceEndPointCode"]} - Edit service
            </h3>
            <div className={classes.formContainer}>
              {servicesFields.map((field, fieldIndex) => {
                if (
                  !data[openedService]
                    .ServiceEndPointCode__NonCustomerEditable &&
                  (isMaintainer
                    ? data[
                        openedService
                      ].ServiceEndPointCode__MaintainerUIRules?.includes(
                        field.name
                      )
                    : data[
                        openedService
                      ].ServiceEndPointCode__UserUIRules?.includes(field.name))
                ) {
                  return (
                    <div
                      key={`${field.name}-${openedService}-${fieldIndex}-modal`}
                    >
                      {dataType[field.name] &&
                        dataType[field.name].FieldType.toUpperCase() ===
                          "URL" && (
                          <div className={classes.modalInputCont}>
                            <label>{field.name || ""}</label>
                            <CertificateField
                              isEditMode={
                                isEditMode &&
                                !data[openedService]
                                  .ServiceEndPointCode__NonCustomerEditable &&
                                (isMaintainer
                                  ? data[
                                      openedService
                                    ].ServiceEndPointCode__MaintainerUIRules?.includes(
                                      field.name
                                    )
                                  : data[
                                      openedService
                                    ].ServiceEndPointCode__UserUIRules?.includes(
                                      field.name
                                    ))
                              }
                              certificateId={data[openedService][field.name]}
                              serviceCode={
                                data[openedService].ServiceEndPointCode
                              }
                              // className={isEditMode && classes.nonEditableText}
                              style={
                                isEditMode &&
                                ((checkDisabled(openedService, field.name) &&
                                  !data[openedService]
                                    .ServiceEndPointCode__NonCustomerEditable &&
                                  field.name !== "ServiceEndPointCode") ||
                                  (field.name === "ServiceEndPointCode" &&
                                    data[openedService]
                                      .ServiceEndPointCode__NonCustomerEditable))
                                  ? { display: "none" }
                                  : null
                              }
                            />
                          </div>
                        )}
                      {(!dataType[field.name] ||
                        dataType[field.name].FieldType.toUpperCase() !==
                          "URL") && (
                        <div className={classes.modalInputCont}>
                          <label
                            htmlFor={`${field.name}-${openedService}-modal`}
                          >
                            {field.name || ""}
                          </label>
                          {dataType[field.name] &&
                          dataType[field.name].Type &&
                          dataType[field.name].Type === "Logical" ? (
                            <select
                              id={`${field.name}-form`}
                              defaultValue={data[openedService][field.name]}
                              onChange={(e) =>
                                handleFieldChange(
                                  openedService,
                                  field.name,
                                  e.target.value
                                )
                              }
                            >
                              <option value="true">True</option>
                              <option value="false">False</option>
                            </select>
                          ) : dataType[field.name] &&
                            dataType[field.name]["_validValues"] &&
                            dataType[field.name]["_validValues"].length > 0 ? (
                            <select
                              id={`${field.name}-form`}
                              defaultValue={data[openedService][field.name]}
                              onChange={(e) =>
                                handleFieldChange(
                                  openedService,
                                  field.name,
                                  e.target.value
                                )
                              }
                              disabled={checkDisabled(
                                openedService,
                                field.name
                              )}
                            >
                              {dataType[field.name]["_validValues"].map(
                                (option, optIndex) => (
                                  <option
                                    key={`${field.name}-option-${optIndex}`}
                                    id={`${field.name}-option-${optIndex}`}
                                    value={option.Title}
                                  >
                                    {option.Title}
                                  </option>
                                )
                              )}
                              <option value=""></option>
                            </select>
                          ) : (
                            <input
                              autoComplete="off"
                              type={
                                // field.isPass
                                //   ? "password"
                                //   :
                                field.isEmail
                                  ? "email"
                                  : dataType[field.name]
                                  ? dataType[field.name].FieldType
                                  : "text"
                              }
                              onFocus={(e) => {
                                if (
                                  dataType[field.name].Type &&
                                  dataType[field.name].Type === "DateTime"
                                ) {
                                  e.currentTarget.type = "date";
                                  e.currentTarget.focus();
                                }
                              }}
                              id={`${field.name}-${openedService}-modal`}
                              defaultValue={data[openedService][field.name]}
                              disabled={checkDisabled(
                                openedService,
                                field.name
                              )}
                              onChange={(e) =>
                                handleFieldChange(
                                  openedService,
                                  field.name,
                                  e.target.value
                                )
                              }
                              onBlur={(e) => {
                                if (field.isEmail) {
                                  if (
                                    !e.currentTarget.checkValidity() &&
                                    e.currentTarget.value.length > 0
                                  )
                                    setIsEmailInvalid(true);
                                  else setIsEmailInvalid(false);
                                }
                              }}
                              className={field.isPass ? classes.key : ""}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  );
                } else return null;
              })}
            </div>
            <div className="text-center mt-3">
              <button
                className={`${classes.refreshBtn} px-4 py-1`}
                onClick={() => {
                  setIsFormOpen(false);
                  setOpenedService(null);
                  setIsEmailInvalid(false);
                }}
              >
                Cancel
              </button>
              <Button
                className={`px-5 py-1 ${classes.saveBtn}`}
                onClick={onSaveValues}
                disabled={isEmailInvalid}
              >
                Save
              </Button>
              {isEmailInvalid && (
                <p className={classes.errorMsg}>
                  Please enter a valid email address.
                </p>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
      {errorSaving && <p>{errorSaving}</p>}
    </>
  );
};

export default ServicesTable;
